import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { env } from "#/lib/env";
import { generateNonce, signVerifyToken } from "#/lib/verify-token";
import { sendVerifyAccount } from "./transactional-email";

const RegisterUserSchema = z.object({
  email: z.string().email(),
  customerId: z.string().min(1),
  customerName: z.string().optional(),
});

export const registerUserFn = createServerFn({ method: "POST" })
  .inputValidator(RegisterUserSchema)
  .handler(async ({ data }) => {
    const token = signVerifyToken(
      {
        customer_id: data.customerId,
        email: data.email,
        nonce: generateNonce(),
      },
      env.EMAIL_VERIFY_SECRET,
    );
    const verificationLink = `${env.APP_URL}/api/callbacks/verify-user?token=${token}`;
    const customerName =
      data.customerName && data.customerName.length > 0
        ? data.customerName
        : (data.email.split("@")[0] ?? data.email);

    await sendVerifyAccount({
      to: data.email,
      customerName,
      verificationLink,
      expiryTime: "24 hours",
    });
  });
